/**
 * Controller for the 'Add Manual Salary' modal.
 *
 * Its single responsibility is to capture a monthly salary from the user.
 * On successful save, it closes the modal and returns the calculated *annual* salary
 * to the caller.
 */
angular.module('psModule').controller('AddSalaryModalCtrl', function ($scope, $uibModalInstance) {
    'use strict';

    $scope.salary = { monthly: null };

    $scope.save = function () {
        if ($scope.addSalaryForm.$valid && $scope.salary.monthly > 0) {
            $uibModalInstance.close($scope.salary.monthly * 12);
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
